// extracted by mini-css-extract-plugin
module.exports = {"root":"bp_bY","body":"bp_b"};